export var allowedDomainList = ['wix.com', 'wixpress.com', 'skoletube.dk', 'wixanswers.com', 'editorx.com'];
export var isValidRedirectUrl = function (url, allowedDomains) {
    if (!url || !isValidUrl(url)) {
        return false;
    }
    var host = new URL(url).host;
    return (allowedDomains.includes(host) ||
        !!allowedDomains.find(function (domain) { return host.includes(".".concat(domain)); }));
};
var isValidUrl = function (str) {
    var url;
    try {
        url = new URL(str);
    }
    catch (_) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
};
//# sourceMappingURL=utils.js.map